const initState={};

const GeneralReportReducer = (state = initState, action) => {
    switch(action.type) {
        case  'GeneralReport' : return  action.payload;
        default: return state;
    }
}
export default GeneralReportReducer;